'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = ['M0 416c0 53 43 96 96 96 15.4 0 30.5-3.7 44-10.7-17.6-23.9-28-53.4-28-85.3 0-45.3 21.3-88 57.6-115.2l64-48c4-3 6.4-7.8 6.4-12.8l0-128-112 0 0 128c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416zM128 48l0 16 112 0 0-16c0-17.5 4.7-33.9 12.8-48L176 0c-26.5 0-48 21.5-48 48zM288 64l0 48 192 0 0-48-192 0z', 'M288 240l0-128 192 0 0 192c0 40.3-19 78.2-51.2 102.4L313.6 492.8c-16.6 12.5-36.8 19.2-57.6 19.2-53 0-96-43-96-96 0-30.2 14.2-58.7 38.4-76.8l64-48C278.5 279.1 288 260.1 288 240zM480 64l-192 0 0-16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 16zM240 64l0 48-112 0 0-48 112 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;